import { Modal } from "@mui/material";
import { Calendario } from "../Calendario/Calendario";


export const ModalMostrarCalendario = ({ open, handleClose }) => {

    return (
        <Modal
            open={open} // Controla si el modal está abierto o cerrado.
            onClose={handleClose} // Llama a la función para cerrar el modal.
            className="modal fade show" // Clase personalizada para estilos adicionales.
            style={{ display: "block" }} // Forzar el estilo para que el modal sea visible.
        >
            <div className="modal-dialog" style={{ maxWidth: "90%", margin: "1.75rem auto" }}>
                <div className="modal-content">
                    <div className="modal-body">
                        <Calendario types="noMostrar"  />
                    </div>
                </div>
            </div>
        </Modal>
    );
};
